import type { z } from "zod";
import type { addCollaboratorInputSchema } from "backend/src/api/schemas/collaborators";

type AddCollaboratorInput = z.infer<typeof addCollaboratorInputSchema>;

export type CollaboratorRole = AddCollaboratorInput["roles"][number];

export const COLLABORATOR_ROLES = [
  "AUTHOR",
  "CO_AUTHOR",
  "COVER_ILLUSTRATOR",
  "INTERNAL_ILLUSTRATOR",
  "INTERNAL_PHOTOGRAPHER",
  "TRANSLATOR",
  "COLLECTIONS_EDITOR",
  "FOREWORD",
  "GHOST_WRITER",
  "PRODUCER",
  "COVER_ART_DESIGNER",
] as const satisfies ReadonlyArray<CollaboratorRole>;
